import { Spinner } from 'flowbite-react';
import React from 'react';
import { useQueryClient } from 'react-query';

interface HiringHeadingProps {
	heading: string;
	subheading: string;
	logoSrc?: string;
}

const HiringHeading: React.FC<HiringHeadingProps> = ({ heading, subheading, logoSrc }) => {
	const queryClient = useQueryClient();
	const data = queryClient.getQueryState(['hiringAssessmentDashboard']);

	return (
		<div className="flex flex-col items-start gap-[2px]">
			<div className="flex items-center gap-[8px]">
				<img src={logoSrc} alt="Logo" className="w-[20px] h-[20px]" />
				<p className="font-inter font-[500] leading-[28px]">{heading}</p>
				{data?.status === 'idle' ? <Spinner size={'sm'} /> : null}
			</div>
			<p className="font-inter text-sm font-[400] leading-[16px] text-gray-500">{subheading}</p>
		</div>
	);
};

export default HiringHeading;
